<template>
    <section class="app-main ">
        <div class="top-bar">
            <el-input  v-model="batch" placeholder="请输入商品批次" class="search-input m-right-2"></el-input>
            <el-button type="success" plain @click="handleConfirm">确认下单</el-button>
        </div>
        <!-- 商品列表 -->
        <el-card shadow="hover" class="adminList">
            <el-table  :data="tableData" empty-text="暂无进货商品" height="600"  style="width: 100%;">
                <el-table-column  label="商品图片" align="center" width="150">
                    <template slot-scope="scope">
                       <table-img :src="scope.row.purchase_pic_url"></table-img>
                    </template>
                </el-table-column>
                <el-table-column  align="center" prop="purchase_title" label="商品名称" width="240" show-overflow-tooltip></el-table-column>
                <el-table-column    align="center"  label="规格属性" width="440" > 
                    <template slot-scope="scope" >
                        <div v-if="scope.row.specs">
                            <div class="m-bottom-1 table-right" v-for="(item, index) in scope.row.specs" :key="index">
                                <el-tag size="medium" class="m-right-3">{{item.attr_symbol_string}}</el-tag>
                                <span>进货价格C$：</span>
                                <el-input  v-model="item.price" @change="updateOrderbuy(item,1)"  size="mini"   style="width:80px" class="m-right-2"></el-input>
                                <span>进货数量：</span>
                                <el-input  v-model="item.number"  @change="updateOrderbuy(item,2)"  size="mini"   style="width:60px"></el-input>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="total_price" align="center" label="单款合计金额">
                    <template slot-scope="scope">C${{scope.row.total_price}}</template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next, jumper" style="padding:10px" :total="total" :page-size="size" @current-change="loadMore"> </el-pagination>
        </el-card>
    </section>
</template>



<script>
import {  purchase_list, purchase_buy, update_orderbuy} from '@/api/buy.js'
import tableImg from '@/components/Image.vue'
export default {
    components:{ tableImg },
    data() {
        return {
            batch:'',
            tableData:[],
            size:10,
            page:1,
            total:0,
        }
    },
    methods: {
        getData(){
            let params = {
                page:this.page,
                belongs: 2
            }
            if(this.title != ""){
                params.title = this.title
            }
            
            purchase_list(1,params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total     = res.data.total
                    this.size      = res.data.per_page
                }else{
                    this.tableData = []
                }

            })
        },
        loadMore(page){
            this.page = page;
            this.getData()
        },
        updateOrderbuy(item,number) {
            let params = {}
            if (number == 1) {
                params.price = item.price
            }else {
                params.number = item.number
            }
            update_orderbuy(item.id,params).then(res => {  
                if(res){
                    this.$message.success(res.msg)
                }
            })
        },
        // 搜索数据
        handleSearch(){
            this.page = 1;
            this.getData();
        },

        // 确认下单
        handleConfirm(){
            if(this.batch == ''){
                this.$message.error('商品批次不能为空')
                return false
            }
            let params = {
                batch:this.batch
            }
            purchase_buy(params).then(res => {
                if(res){
                   this.$message({type:'success', message:res.msg, duration:1500})
                   this.getData() 
                }
            })
        },
    },
    mounted () {
        this.getData();
    },
    activated() {
        this.getData()
    },
}
</script>


<style lang="less" scoped>
section {
    .table-right {
        text-align: right;
    }
}
</style>



